import { EspAccount } from 'modules/graphql/types';
import { DynCreateModal } from './Modals/DynCreateModal';
import { DynEditModal } from './Modals/DynEditModal';
import { MailgunCreateModal } from './Modals/MailgunCreateModal';
import { MailgunEditModal } from './Modals/MailgunEditModal';
import { SendgridCreateModal } from './Modals/SendgridCreateModal';
import { SendgridEditModal } from './Modals/SendgridEditModal';
import { SparkpostCreateModal } from './Modals/SparkpostCreateModal';
import { SparkpostEditModal } from './Modals/SparkpostEditModal';
import { CustomEmailCreateModal } from './Modals/CustomEmailCreateModal';
import { CustomEmailEditModal } from './Modals/CustomEmailEditModal';
import { DisconnectAccountModal } from '../Shared/DisconnectAccountModal';
import { ResetDefaultSenderModal } from './DefaultSender/ResetDefaultSenderModal';
import { SetDefaultSenderModal } from './DefaultSender/SetDefaultSenderModal';
import {
  MODAL_ACTION,
  useModalsContext,
  CreateAccountFormProvider,
  EditAccountFormProvider,
  useSendingPlatformsQueryContext,
} from '../../../contexts';
import {
  CUSTOM_EMAIL,
  SPARKPOST,
  MAILGUN,
  DYN,
  SENDGRID,
  ConfigurableSendingPlatforms,
} from '../../../constants';

export const CreateModalBySendingPlatform = {
  [SPARKPOST]: SparkpostCreateModal,
  [MAILGUN]: MailgunCreateModal,
  [DYN]: DynCreateModal,
  [SENDGRID]: SendgridCreateModal,
  [CUSTOM_EMAIL]: CustomEmailCreateModal,
};

export const EditModalBySendingPlatform = {
  [SPARKPOST]: SparkpostEditModal,
  [MAILGUN]: MailgunEditModal,
  [DYN]: DynEditModal,
  [SENDGRID]: SendgridEditModal,
  [CUSTOM_EMAIL]: CustomEmailEditModal,
};

export const EmailModals = () => {
  const { modalState } = useModalsContext();
  const { selectEspAccount, espDefinitions } = useSendingPlatformsQueryContext();

  if (modalState === null) return null;

  const { action } = modalState;
  const sendingPlatform = modalState.sendingPlatform as ConfigurableSendingPlatforms;
  const espAccountId = modalState.espAccountId as number;
  const espAccount = selectEspAccount(espAccountId) as EspAccount;

  switch (action) {
    case MODAL_ACTION.CREATE_ACCOUNT_INTEGRATION: {
      const CreateModal =
        CreateModalBySendingPlatform[sendingPlatform as keyof typeof CreateModalBySendingPlatform];
      return (
        <CreateAccountFormProvider
          sendingPlatform={sendingPlatform}
          espDefinitions={espDefinitions}
        >
          <CreateModal />
        </CreateAccountFormProvider>
      );
    }

    case MODAL_ACTION.EDIT_ACCOUNT_INTEGRATION: {
      const EditModal =
        EditModalBySendingPlatform[sendingPlatform as keyof typeof EditModalBySendingPlatform];
      return (
        <EditAccountFormProvider espAccount={espAccount}>
          <EditModal />
        </EditAccountFormProvider>
      );
    }

    case MODAL_ACTION.DISCONNECT_ACCOUNT:
      return <DisconnectAccountModal espAccountId={espAccountId} />;

    case MODAL_ACTION.SET_DEFAULT_SENDER:
      return <SetDefaultSenderModal espAccountId={espAccountId} />;
    case MODAL_ACTION.RESET_DEFAULT_SENDER:
      return <ResetDefaultSenderModal espAccountId={espAccountId} />;

    default:
      return null;
  }
};
